import React, { useEffect, useState } from 'react';
import { ModalFactory } from '../../components/modal/modal';
import {
  AppMigrationContainer,
  AppMigrationModal,
  AppMigrationFlagWrapper,
  FeesWrapper
} from './appMigration.style';
import { getContentSchemaFromContentFul } from '../../redux/actions/common/common-action';
import getDeviceWidth from '../../hooks/getDeviceWidth';
import { Dispatch } from 'redux';
import { store } from '../../store';
import get from 'lodash/get';
import { INSTAREM_APP_MIGRATION_ONE_LINK } from '../../utils/constants';
import processCmsData from '../../../src/utils/cmsData/index';
import messages from '../../messages/containers/appMigration';
import isEmpty from 'lodash/isEmpty';
import CommonButton from '../../components/common-button/CommonButton';
import { storeUserConsent } from '@Redux/actions/user-flow';
import { CROSS_ICON, NEW_APP_PRICING_ICON } from '@Images';
interface IAppMigration {
  source_currency?: string;
  className: string;
  dontShowFee?: boolean;
  dispatch?: any;
}

interface cmsDataStructure {
  showMeHowButton_label: string;
  getBeeterRatesWithFessLabel: string;
  flagLabel: string;
  getBeeterRatesLabel: string;
  downloadBtn_label: string;
  downloadNow: string;
}

let cmsData: any = null;

const getAppMigrationCmsData = async () => {
  if (!cmsData) {
    const res = await getContentSchemaFromContentFul('pageAppMigration', 'APP_MIGRATION');
    const processedData: any = !isEmpty(res) ? processCmsData(res) : messages;
    cmsData = processedData;
    return processedData;
  } else {
    return cmsData;
  }
};

const AppMigration: React.FC<IAppMigration> = (props) => {
  const { className = '', dontShowFee } = props;
  const deviceWidth = getDeviceWidth().width;
  const isMobile = deviceWidth ? deviceWidth <= 768 : false;

  const [cmsData, setCmsData] = useState<cmsDataStructure>();
  const reduxStore = store.getState();

  const source_currency: string = get(
    reduxStore,
    'rootReducer.transactionReducer.transactionDetails.source_currency',
    ''
  );
  const destinantion_currency: string = get(
    reduxStore,
    'rootReducer.transactionReducer.transactionDetails.destination_currency',
    ''
  );

  let app_fee_difference = Number(
    get(
      reduxStore,
      'rootReducer.transactionReducer.transactionDetails.transaction_config.app_fee_difference',
      0
    )
  );
  const app_fx_rate = Number(
    get(
      reduxStore,
      'rootReducer.transactionReducer.transactionDetails.transaction_config.app_fx_rate',
      0
    )
  );

  const instarem_fx_rate = Number(
    get(reduxStore, 'rootReducer.transactionReducer.transactionDetails.instarem_fx_rate', 0)
  );
  const regular_instarem_fx_rate = Number(
    get(reduxStore, 'rootReducer.transactionReducer.transactionDetails.regular_instarem_fx_rate', 0)
  );
  const first_instarem_transaction = Boolean(
    get(
      reduxStore,
      'rootReducer.transactionReducer.transactionDetails.first_instarem_transaction',
      false
    )
  );
  if (app_fee_difference % 1 !== 0) app_fee_difference = +app_fee_difference.toFixed(2);
  let getBeeterRates = cmsData?.getBeeterRatesWithFessLabel?.replace(
    '{value}',
    app_fee_difference.toString()
  );
  getBeeterRates = getBeeterRates?.replace('{currency}', source_currency.toString());
  const getCmsData = async () => {
    const res = await getAppMigrationCmsData();
    setCmsData(res);
    return res;
  };

  useEffect(() => {
    if (!cmsData) {
      getCmsData();
    }
  }, [cmsData]);
  return (
    <>
      {(!first_instarem_transaction || regular_instarem_fx_rate === instarem_fx_rate) && (
        <AppMigrationContainer id="app_migration_container" className={className}>
          {dontShowFee ? (
            <div>
              <p>{cmsData?.getBeeterRatesLabel}</p>
            </div>
          ) : (
            <div>
              {app_fee_difference > 0 && (
                <span id="app_migration_dynamic_text">
                  {getBeeterRates ||
                    `This transfer is ${app_fee_difference.toString()} ${source_currency} cheaper`}
                </span>
              )}
            </div>
          )}

          {app_fx_rate > instarem_fx_rate && (
            <FeesWrapper>
              {`In-app rate is `} <br></br>
              {`1 ${source_currency} = `}
              <s> {`${instarem_fx_rate} ${destinantion_currency}`} </s>{' '}
              {` ${app_fx_rate} ${destinantion_currency}`}
            </FeesWrapper>
          )}

          {cmsData?.downloadNow + ' '}
          {isMobile ? (
            <CommonButton
              text={cmsData?.downloadBtn_label || 'Download app'}
              id="app_migration_btn_mobile"
              onClick={() => openLinkInNewWindow()}
              type="link"
            />
          ) : (
            <CommonButton
              text={cmsData?.showMeHowButton_label || 'Show me how'}
              id="app_migration_btn_web"
              onClick={() =>
                appMigrationModal(
                  { app_fee_difference: app_fee_difference.toString(), source_currency },
                  destinantion_currency,
                  instarem_fx_rate,
                  app_fx_rate,
                  app_fee_difference,
                  false,
                  null,
                  isMobile
                )
              }
              type="link"
            />
          )}
        </AppMigrationContainer>
      )}
    </>
  );
};

const openLinkInNewWindow = async () => {
  const url = INSTAREM_APP_MIGRATION_ONE_LINK;
  await window.open(url, '_blank');
};

const appMigrationModal = async (
  feeDetails: {
    app_fee_difference: string | number;
    source_currency: string;
  },
  destinantion_currency: string,
  instarem_fx_rate: number,
  app_fx_rate: number,
  app_fee_difference: number,
  getUserConsent?: boolean,
  dispatch?: Dispatch | any,
  isMobile?: boolean
): Promise<any> => {
  const reduxStore = store.getState();
  const fx_rate = Number(
    get(reduxStore, 'rootReducer.transactionReducer.transactionDetails.instarem_fx_rate', 0)
  );
  if (!instarem_fx_rate) {
    instarem_fx_rate = fx_rate;
  }
  const getCmsData = async () => {
    const cmsData = await getContentSchemaFromContentFul('pageAppMigration', 'APP_MIGRATION');
    if (isEmpty(cmsData)) return messages;
    else return processCmsData(cmsData);
  };
  const cmsData: any = await getCmsData();
  if (Number(feeDetails.app_fee_difference) % 1 !== 0)
    feeDetails.app_fee_difference = +Number(feeDetails.app_fee_difference);
  const handleApiCall = async (user_consent: boolean, onClose: any) => {
    dispatch && (await dispatch(storeUserConsent({ user_consent, brand: 'INSTAREM_MOBILE' })));
    await onClose();
    isMobile && user_consent && openLinkInNewWindow();
  };

  //@ts-ignore
  await ModalFactory.builder(
    (onClose: any) => (
      <AppMigrationModal id="fee_difference_content">
        <img
          width={'12px'}
          className="close-icon"
          src={CROSS_ICON}
          alt="close"
          onClick={async () => {
            getUserConsent && (await handleApiCall(false, onClose));
            onClose && (await onClose());
          }}
        />
        <h1 className="highlight-fee" id="fee_difference">
          {cmsData.modalHeading_heading ||
            `Get it ${feeDetails.app_fee_difference.toString()} ${
              feeDetails.source_currency
            } cheaper`}
        </h1>
        <h1 className="margin-vertical">
          {cmsData.modalHeading_subHeading || 'with the Instarem app'}
        </h1>
        <p id="app_migration_text" className="content">
          {isMobile ? (
            <>
              <strong className="highlight-fee" id="fee_difference">
                {cmsData.modalContent_subHeading}
              </strong>
              {app_fx_rate > instarem_fx_rate && (
                <FeesWrapper>
                  {`In-app rate is `} <br></br>
                  {`1 ${feeDetails.source_currency} = `}
                  <s> {`${instarem_fx_rate} ${destinantion_currency}`} </s>{' '}
                  {` ${app_fx_rate} ${destinantion_currency}`}
                </FeesWrapper>
              )}
              <div>
                <p>{cmsData?.extras?.mobile_app_download}</p>
              </div>
            </>
          ) : (
            <>
              <strong className="highlight-fee" id="fee_difference">
                {cmsData.modalContent_subHeading}
              </strong>
              {app_fx_rate > instarem_fx_rate && (
                <FeesWrapper>
                  {`In-app rate is `} <br></br>
                  {`1 ${feeDetails.source_currency} = `}
                  <s> {`${instarem_fx_rate} ${destinantion_currency}`} </s>{' '}
                  {` ${app_fx_rate} ${destinantion_currency}`}
                </FeesWrapper>
              )}
              <div>
                <p>{cmsData['modalContent_heading']}</p>
              </div>
            </>
          )}
        </p>
        {!isMobile && (
          <img
            src={NEW_APP_PRICING_ICON}
            className="instarem-qrcode"
            alt="instarem_qrcode"
            id="instarem_qrcode"
          />
        )}
        {getUserConsent ? (
          <>
            <CommonButton
              text={cmsData?.getTheAppBtn_label}
              onClick={() => handleApiCall(true, onClose)}
              id="user_consent_yes"
              className="center-btn add-margin-top"
            />
            <div className="add-margin-top">
              <CommonButton
                text={cmsData.proceedOnWebBtn_label}
                id="user_consent_no"
                className="center-btn "
                onClick={() => handleApiCall(false, onClose)}
                type="link"
              />
            </div>
          </>
        ) : (
          <CommonButton
            text={cmsData['modalSubmitButton_label']}
            onClick={onClose}
            width={335}
            height={46}
            id="close_btn_app_migration"
            className="center-btn add-margin-top"
          />
        )}
      </AppMigrationModal>
    ),
    'center-modal',
    true,
    { disAbleCloseAnimation: true }
  );
};

const AppMigrationFlag: React.FC<{ className?: string }> = (props) => {
  interface cmsDataStructure {
    flagLabel: string;
  }
  const [cmsData, setCmsData] = useState<cmsDataStructure>();
  const { className = '' } = props;
  const reduxStore = store.getState();

  const instarem_fx_rate = Number(
    get(reduxStore, 'rootReducer.transactionReducer.transactionDetails.instarem_fx_rate', 0)
  );
  const regular_instarem_fx_rate = Number(
    get(reduxStore, 'rootReducer.transactionReducer.transactionDetails.regular_instarem_fx_rate', 0)
  );
  const first_instarem_transaction = Boolean(
    get(
      reduxStore,
      'rootReducer.transactionReducer.transactionDetails.first_instarem_transaction',
      false
    )
  );
  const getCmsData = async () => {
    const res = await getAppMigrationCmsData();
    setCmsData(res);
    return res;
  };
  useEffect(() => {
    getCmsData();
  }, []);

  return (
    <>
      {(!first_instarem_transaction || regular_instarem_fx_rate === instarem_fx_rate) && (
        <AppMigrationFlagWrapper id="migration_flag" className={className}>
          {cmsData?.flagLabel}
        </AppMigrationFlagWrapper>
      )}
    </>
  );
};

export { AppMigration, appMigrationModal, AppMigrationFlag };
